import React from 'react';
import {Badge} from "react-bootstrap";

export const DateBadge = ({children}) => (<Badge variant='default'>{children.format('MM/DD')}</Badge>);
